(() => {
  const controllerKey = '__protonFlamingoViewController';
  const initialUrl = new URL(window.location.href);
  const previewThemeId = initialUrl.searchParams.get('preview_theme_id');
  const galleryKey = initialUrl.searchParams.get('gallery');

  if (initialUrl.searchParams.get('view') !== 'flamingo') return;

  window[controllerKey]?.abort();
  const controller = new AbortController();
  window[controllerKey] = controller;

  document.addEventListener('change', (event) => {
    if (!event.target.closest('variant-radios, variant-selects')) return;
    if (!document.querySelector('.proton-flamingo')) return;

    // Dawn updates variant state and the URL in its own change handler. Run
    // immediately afterward and restore only the alternate-template query.
    window.setTimeout(() => {
      const url = new URL(window.location.href);
      if (!url.pathname.includes('/products/')) return;
      url.searchParams.set('view', 'flamingo');
      if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);
      if (galleryKey) url.searchParams.set('gallery', galleryKey);
      window.history.replaceState(window.history.state, '', url);
    }, 0);
  }, { signal: controller.signal });

  document.addEventListener('shopify:section:unload', (event) => {
    if (!event.target.querySelector?.('.proton-flamingo')) return;
    controller.abort();
    if (window[controllerKey] === controller) delete window[controllerKey];
  }, { signal: controller.signal });
})();
